import React, {useEffect, useState} from 'react'
import {
  Blacked,
  DBModalMemoArea, MemoSubmitBtn,
  ModalContent,
  ModalHeader,
  ModalInput,
  ModalSubmit,
  ModalTitle,
  ModalWrapper
} from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import {FaChevronLeft, FaPen, FaTrash} from 'react-icons/fa6';
import {Input, message, Table} from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { useBranchList } from 'CRM/hooks/GetBranchList';
import TextArea from "antd/es/input/TextArea";
import { useReadNotiList} from "../../hooks/GetReadNotiInfoList";
import {useIsMobile} from "../IsMobile";

export const MessageModal = ({setMessegeModal, notiInfoMutate }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { readNotiList, readNotiListMutate } = useReadNotiList();
  // const [name, setName] = useState(data?.name || '');
  // const [desc, setDesc] = useState(data?.desc || '');
  // const [localNotiInfo, setLocalNotiInfo] = useState([
  //   {
  //     id: '',
  //     message: '',
  //     createdAt: ''
  //   }
  // ]);

  useEffect(() => {
    CallNoti();
  }, []);


  const CallNoti =  () => {
    API.post('/dashboard/noti?unread=1', token + '', {})
      .then((res: any) => {
        if (res.result.success) {
          // console.log('res', res)
          notiInfoMutate();
        } else {

        }
      })
  }

  // const clickSubmit = () => {
  //   const shouldEdit = window.confirm(`수정하실 내용이 맞습니까? \n 지사: ${name} \n 설명: ${desc}`);
  //   if(shouldEdit) {
  //     if(name == '') {
  //       message.error('지사명은 필수 입력입니다.')
  //     } else {
  //       API.put('/system/branch/' + data?.id, token + '', {
  //         datas: {
  //           name: name,
  //           desc: desc
  //         }
  //       })
  //       .then((res: any) => {
  //         if (res.result.success) {
  //           message.success('수정되었습니다');
  //           mutate();
  //           setIsEdit(false);
  //         }
  //       })
  //       .catch((err: any) => {})
  //     }
  //   }
  // }

  const mobileColumns = [
    {
      dataIndex: 'id',
      title: <div style={{ display: 'flex',justifyContent: 'center' }}>ID</div>,
      render: (value, data) => {
        return (
          <div style={{ display: 'flex',justifyContent: 'center' }}>
            {data?.id}
          </div>
        )
      },
    },
    {
      dataIndex: 'message',
      title: <div style={{ display: 'flex',justifyContent: 'center'}}>메세지</div>,
      render: (value, data) => {
        return (
          <>
            <div style={{ display: 'flex',justifyContent: 'start' }}>
              <p style={{marginRight: 5, fontWeight: 'bold', minWidth: 30}}>내용: </p>
              {data?.message}
            </div>
            <div style={{ display: 'flex',justifyContent: 'start' }}>
              <p style={{marginRight: 5, fontWeight: 'bold', minWidth: 45}}>작성일: </p>
              {data?.created_at}
            </div>
          </>
        )
      },
    },
  ]

  const columns = [
    {
      dataIndex: 'id',
      title: <div style={{ display: 'flex',justifyContent: 'center' }}>ID</div>,
      render: (value, data) => {
        return (
          <div style={{ display: 'flex',justifyContent: 'center' }}>
            {data?.id}
          </div>
        )
      },
    },
    {
      dataIndex: 'message',
      title: <div style={{ display: 'flex',justifyContent: 'center'}}>메세지</div>,
      render: (value, data) => {
        return (
          <div style={{ display: 'flex',justifyContent: 'center' }}>
            {data?.message}
          </div>
        )
      },
    },
    {
      dataIndex: 'createdAt',
      title: <div style={{ display: 'flex',justifyContent: 'center'}}>작성일</div>,
      render: (value, data) => {
        return (
          <div style={{ display: 'flex',justifyContent: 'center' }}>
            {data?.created_at}
          </div>
        )
      },
    },

  ]

  return (
    <>
      <Blacked onClick={() => setMessegeModal(false)} style={{zIndex: IsMobile ? 9999 : 99}} />
      {IsMobile ?
        <ModalWrapper IsMobile={IsMobile} style={{zIndex: IsMobile ? 9999 : 99, top: IsMobile && 0}}>
          <ModalHeader>
            <Icon onClick={() => setMessegeModal(false)}><FaChevronLeft /></Icon>
            <ModalTitle>메세지함</ModalTitle>
            <ModalSubmit style={{opacity: 0}} >저장</ModalSubmit>
          </ModalHeader>
          <ModalContent>
            <Table dataSource={readNotiList} columns={mobileColumns} />
          </ModalContent>
        </ModalWrapper>
      :
        <ModalWrapper style={{width: '80%'}}>
          <ModalHeader>
            <Icon onClick={() => setMessegeModal(false)}><FaChevronLeft /></Icon>
            <ModalTitle>메세지함</ModalTitle>
            <ModalSubmit style={{opacity: 0}} >저장</ModalSubmit>
          </ModalHeader>
          <ModalContent>
            <Table dataSource={readNotiList} columns={columns} />
          </ModalContent>
        </ModalWrapper>
      }

    </>
  )
}
